export enum ModalType {
  Genres = 'genres',
  Languages = 'languages',
  Comment = 'comment',
  Artists = 'artists',
  CreatorType = 'creatorType',
  Countries = 'countries',
  AdVisual = 'adVisual',
  AdVisualSuccess = 'adVisualSuccess',
  AdsPlacements = 'adsPlacements',
  AiUsage = 'aiUsage',
  TrackFile = 'trackFile',
  ReleaseDate = 'releaseDate',
}

export enum ScheduleSteps {
  SETTINGS = 'settings',
  TYPE = 'type',
  CHECKOUT = 'checkout',
}

export type CustomEmbedRef = {
  open: () => void
}

export enum FeedFilterType {
  date = 'date',
  genres = 'genres',
  playlists = 'playlists',
  curatorIsFavorite = 'curatorIsFavorite',
}

export enum FeedFilterDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
